import { Component } from '@angular/core';

@Component({
  selector: 'app-list-attendance',
  standalone: true,
  templateUrl: './list-attendance.component.html',
  styleUrl: './list-attendance.component.css',
})
export class ListAttendanceComponent {}
